export default "__VITE_ASSET__Cs4d4Ubh__"